import { render } from "./ProsesEnvironment.vue?vue&type=template&id=e80c893a"
import script from "./ProsesEnvironment.vue?vue&type=script&lang=js"
export * from "./ProsesEnvironment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__